export const initialPointerCache = [];
export function pointerCache_updatePosition(pointerCache, pointerId, newPosition) {
    return pointerCache.map(cacheEntry => cacheEntry.pointerId === pointerId
        ? Object.assign(Object.assign({}, cacheEntry), { lastPosition: newPosition }) : cacheEntry);
}
export function pointerCache_addEntry(pointerCache, pointerId, position) {
    return [...pointerCache, { pointerId: pointerId, lastPosition: position }];
}
export function pointerCache_removeEntry(pointerCache, pointerId) {
    return pointerCache.filter(cacheEntry => cacheEntry.pointerId !== pointerId);
}
